module.exports = __webpack_public_path__ + "media/home/plan-feature-basic-88dbd788.jpg";